export default __webpack_public_path__ + "assets/images/59b90c8937ebce122a70ea4303e422c7.png";